// University of Hawaii at Manoa's undergraduate majors (#2652). Read on
// 2026-10-01 from the official 2026-2027 UH Manoa Catalog
// (catalog.manoa.hawaii.edu, catoid=4), "Programs by College/School and
// Department", which lists every program under its college or school with
// the degree. Each bachelor's major is kept once per degree: tracks,
// concentrations, options and pathways ("Earth Sciences: Volcano Science
// Concentration, BS", "Art: Art History Track, BA") are folded into their
// major. Left out: combined bachelor's and master's (BAM) pathways, programs
// paired with a post-baccalaureate certificate, programs the catalog marks
// "currently not admitting" (the Elementary Education Special Education
// Track and the Interdisciplinary Studies Linguistics Concentration), minors,
// certificates and graduate programs. Interdisciplinary Studies, BA appears
// under the three units that list it. Degree abbreviations are the
// catalog's own (BA, BS, BBA, BEd, BFA, BMus, BEnvD, BSW). Group names keep
// the catalog's Hawaiian spelling. The KB's majors list was the starting
// point; the catalog wins.
const majors = {
    "slug": "university-of-hawaii-at-manoa",
    "read": "2026-10-01",
    "intro": "Every bachelor's degree major in the 2026-2027 UH Manoa Catalog, grouped by the college or school that offers it, with the degree it leads to. Tracks and concentrations are folded into their major; combined bachelor's and master's pathways, minors, certificates and graduate programs are left out.",
    "groups": [
        {
            "name": "College of Arts, Languages & Letters",
            "source": {
                "label": "UH Manoa 2026-2027 Catalog, Programs by College/School and Department",
                "url": "https://catalog.manoa.hawaii.edu/content.php?catoid=4&navoid=1212"
            },
            "majors": [
                {
                    "name": "American Studies",
                    "degree": "BA"
                },
                {
                    "name": "Art",
                    "degree": "BA"
                },
                {
                    "name": "Art",
                    "degree": "BFA"
                },
                {
                    "name": "Asian Studies",
                    "degree": "BA"
                },
                {
                    "name": "Chinese",
                    "degree": "BA"
                },
                {
                    "name": "Cinematic Arts",
                    "degree": "BA"
                },
                {
                    "name": "English",
                    "degree": "BA"
                },
                {
                    "name": "History",
                    "degree": "BA"
                },
                {
                    "name": "Japanese",
                    "degree": "BA"
                },
                {
                    "name": "Korean",
                    "degree": "BA"
                },
                {
                    "name": "Languages & Literatures of Europe & the Americas",
                    "degree": "BA"
                },
                {
                    "name": "Linguistics",
                    "degree": "BA"
                },
                {
                    "name": "Music",
                    "degree": "BA"
                },
                {
                    "name": "Music",
                    "degree": "BMus"
                },
                {
                    "name": "Pacific Islands Studies",
                    "degree": "BA"
                },
                {
                    "name": "Philippine Language and Culture",
                    "degree": "BA"
                },
                {
                    "name": "Philosophy",
                    "degree": "BA"
                },
                {
                    "name": "Religious Traditions & Ancient Civilizations",
                    "degree": "BA"
                },
                {
                    "name": "Second Language Studies",
                    "degree": "BA"
                },
                {
                    "name": "Theatre and Dance",
                    "degree": "BA"
                },
                {
                    "name": "Theatre and Dance",
                    "degree": "BFA"
                }
            ]
        },
        {
            "name": "College of Education",
            "source": {
                "label": "UH Manoa 2026-2027 Catalog, Programs by College/School and Department",
                "url": "https://catalog.manoa.hawaii.edu/content.php?catoid=4&navoid=1212"
            },
            "majors": [
                {
                    "name": "Elementary Education",
                    "degree": "BEd"
                },
                {
                    "name": "Kinesiology and Rehabilitation Science",
                    "degree": "BS"
                },
                {
                    "name": "Secondary Education",
                    "degree": "BEd"
                },
                {
                    "name": "Special Education",
                    "degree": "BEd"
                }
            ]
        },
        {
            "name": "College of Engineering",
            "source": {
                "label": "UH Manoa 2026-2027 Catalog, Programs by College/School and Department",
                "url": "https://catalog.manoa.hawaii.edu/content.php?catoid=4&navoid=1212"
            },
            "majors": [
                {
                    "name": "Civil Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Computer Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Construction Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Electrical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "College of Natural Sciences",
            "source": {
                "label": "UH Manoa 2026-2027 Catalog, Programs by College/School and Department",
                "url": "https://catalog.manoa.hawaii.edu/content.php?catoid=4&navoid=1212"
            },
            "majors": [
                {
                    "name": "Astronomy",
                    "degree": "BA"
                },
                {
                    "name": "Astrophysics",
                    "degree": "BS"
                },
                {
                    "name": "Biochemistry",
                    "degree": "BA"
                },
                {
                    "name": "Biochemistry",
                    "degree": "BS"
                },
                {
                    "name": "Biology",
                    "degree": "BA"
                },
                {
                    "name": "Biology",
                    "degree": "BS"
                },
                {
                    "name": "Botany",
                    "degree": "BA"
                },
                {
                    "name": "Botany",
                    "degree": "BS"
                },
                {
                    "name": "Chemistry",
                    "degree": "BA"
                },
                {
                    "name": "Chemistry",
                    "degree": "BS"
                },
                {
                    "name": "Computer Science",
                    "degree": "BS"
                },
                {
                    "name": "Information and Computer Sciences",
                    "degree": "BA"
                },
                {
                    "name": "Marine Biology",
                    "degree": "BA"
                },
                {
                    "name": "Marine Biology",
                    "degree": "BS"
                },
                {
                    "name": "Mathematics",
                    "degree": "BA"
                },
                {
                    "name": "Mathematics",
                    "degree": "BS"
                },
                {
                    "name": "Microbiology",
                    "degree": "BA"
                },
                {
                    "name": "Microbiology",
                    "degree": "BS"
                },
                {
                    "name": "Molecular Cell Biology",
                    "degree": "BS"
                },
                {
                    "name": "Physics",
                    "degree": "BA"
                },
                {
                    "name": "Physics",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "College of Social Sciences",
            "source": {
                "label": "UH Manoa 2026-2027 Catalog, Programs by College/School and Department",
                "url": "https://catalog.manoa.hawaii.edu/content.php?catoid=4&navoid=1212"
            },
            "majors": [
                {
                    "name": "Anthropology",
                    "degree": "BA"
                },
                {
                    "name": "Communication",
                    "degree": "BA"
                },
                {
                    "name": "Communicology",
                    "degree": "BA"
                },
                {
                    "name": "Economics",
                    "degree": "BA"
                },
                {
                    "name": "Ethnic Studies",
                    "degree": "BA"
                },
                {
                    "name": "Geography and Environment",
                    "degree": "BA"
                },
                {
                    "name": "Interdisciplinary Studies",
                    "degree": "BA"
                },
                {
                    "name": "Journalism",
                    "degree": "BA"
                },
                {
                    "name": "Political Science",
                    "degree": "BA"
                },
                {
                    "name": "Psychology",
                    "degree": "BA"
                },
                {
                    "name": "Psychology",
                    "degree": "BS"
                },
                {
                    "name": "Sociology",
                    "degree": "BA"
                },
                {
                    "name": "Women, Gender, and Sexuality Studies",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "College of Tropical Agriculture and Human Resilience",
            "source": {
                "label": "UH Manoa 2026-2027 Catalog, Programs by College/School and Department",
                "url": "https://catalog.manoa.hawaii.edu/content.php?catoid=4&navoid=1212"
            },
            "majors": [
                {
                    "name": "Animal Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Biological Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Dietetics",
                    "degree": "BS"
                },
                {
                    "name": "Fashion Design and Merchandising",
                    "degree": "BS"
                },
                {
                    "name": "Food Science and Human Nutrition",
                    "degree": "BS"
                },
                {
                    "name": "Human Development and Family Science",
                    "degree": "BS"
                },
                {
                    "name": "Molecular Biosciences and Biotechnology",
                    "degree": "BS"
                },
                {
                    "name": "Natural Resources and Environmental Management",
                    "degree": "BS"
                },
                {
                    "name": "Tropical Agriculture and the Environment",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "Hawai\u02bbinui\u0101kea School of Hawaiian Knowledge",
            "source": {
                "label": "UH Manoa 2026-2027 Catalog, Programs by College/School and Department",
                "url": "https://catalog.manoa.hawaii.edu/content.php?catoid=4&navoid=1212"
            },
            "majors": [
                {
                    "name": "Hawaiian",
                    "degree": "BA"
                },
                {
                    "name": "Hawaiian Studies",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "Institute for Sustainability and Resilience",
            "source": {
                "label": "UH Manoa 2026-2027 Catalog, Programs by College/School and Department",
                "url": "https://catalog.manoa.hawaii.edu/content.php?catoid=4&navoid=1212"
            },
            "majors": [
                {
                    "name": "Interdisciplinary Studies",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "John A. Burns School of Medicine",
            "source": {
                "label": "UH Manoa 2026-2027 Catalog, Programs by College/School and Department",
                "url": "https://catalog.manoa.hawaii.edu/content.php?catoid=4&navoid=1212"
            },
            "majors": [
                {
                    "name": "Medical Technology",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "Office of the Vice Provost for Academic Excellence",
            "source": {
                "label": "UH Manoa 2026-2027 Catalog, Programs by College/School and Department",
                "url": "https://catalog.manoa.hawaii.edu/content.php?catoid=4&navoid=1212"
            },
            "majors": [
                {
                    "name": "Interdisciplinary Studies",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "School of Architecture",
            "source": {
                "label": "UH Manoa 2026-2027 Catalog, Programs by College/School and Department",
                "url": "https://catalog.manoa.hawaii.edu/content.php?catoid=4&navoid=1212"
            },
            "majors": [
                {
                    "name": "Environmental Design",
                    "degree": "BEnvD"
                }
            ]
        },
        {
            "name": "School of Nursing and Dental Hygiene",
            "source": {
                "label": "UH Manoa 2026-2027 Catalog, Programs by College/School and Department",
                "url": "https://catalog.manoa.hawaii.edu/content.php?catoid=4&navoid=1212"
            },
            "majors": [
                {
                    "name": "Dental Hygiene",
                    "degree": "BS"
                },
                {
                    "name": "Nursing",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "School of Ocean and Earth Science and Technology",
            "source": {
                "label": "UH Manoa 2026-2027 Catalog, Programs by College/School and Department",
                "url": "https://catalog.manoa.hawaii.edu/content.php?catoid=4&navoid=1212"
            },
            "majors": [
                {
                    "name": "Atmospheric Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Earth Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Environmental Earth Sciences",
                    "degree": "BA"
                },
                {
                    "name": "Global Environmental Science",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "Shidler College of Business",
            "source": {
                "label": "UH Manoa 2026-2027 Catalog, Programs by College/School and Department",
                "url": "https://catalog.manoa.hawaii.edu/content.php?catoid=4&navoid=1212"
            },
            "majors": [
                {
                    "name": "Accounting",
                    "degree": "BBA"
                },
                {
                    "name": "Entrepreneurship",
                    "degree": "BBA"
                },
                {
                    "name": "Finance",
                    "degree": "BBA"
                },
                {
                    "name": "General Business",
                    "degree": "BBA"
                },
                {
                    "name": "Human Resource Management",
                    "degree": "BBA"
                },
                {
                    "name": "International Business",
                    "degree": "BBA",
                    "note": "Second major only."
                },
                {
                    "name": "Management",
                    "degree": "BBA"
                },
                {
                    "name": "Management Information Systems",
                    "degree": "BBA"
                },
                {
                    "name": "Marketing",
                    "degree": "BBA"
                },
                {
                    "name": "Travel Industry Management",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "Thompson School of Social Work & Public Health",
            "source": {
                "label": "UH Manoa 2026-2027 Catalog, Programs by College/School and Department",
                "url": "https://catalog.manoa.hawaii.edu/content.php?catoid=4&navoid=1212"
            },
            "majors": [
                {
                    "name": "Public Health",
                    "degree": "BA"
                },
                {
                    "name": "Social Work",
                    "degree": "BSW"
                }
            ]
        }
    ]
};

export default majors;
